// @flow
import * as React from 'react';
import styled from 'styled-components';
import { colors, transition } from '../theme';

const RadioContainer = styled.div`
  display: inline-flex;
  min-height: 35px;
`;

const StyledLabel = styled.label`
  font-size: 18px;
  color: ${colors.battleshipGrey};
  padding-left: 11px;
  cursor: pointer;
`;

const StyledRadio = styled.input`
  appearance: none;
  background-color: ${colors.white};
  height: 16px;
  width: 16px;
  min-width: 16px;
  border: solid 1px ${colors.battleshipGrey};
  border-radius: 50%;
  padding: 3px;
  cursor: pointer;
  margin: 4px 0 3px;
  transition: all ${transition};
  &:checked {
    background-clip: content-box;
    background-color: ${colors.waterBlue};
  }
  &:focus {
    border-color: ${colors.waterBlue};
    box-shadow: 0 0 0 1px ${colors.waterBlue};
    outline: 0;
  }
  &[disabled] {
    background: ${colors.silver};
    opacity: 0.5;
    cursor: auto;
    + label {
      opacity: 0.5;
    }
  }
`;

const RadioButton = ({
  id,
  name,
  value,
  label,
  checked,
  onChange,
  ...props
}: {
  id?: string,
  name?: string,
  value: string | boolean | number,
  label: React.Node,
  checked: boolean,
  onChange: (string | boolean | number) => void
}) => (
  <RadioContainer>
    <StyledRadio
      type="radio"
      name={name}
      id={id}
      checked={checked}
      value={typeof value === 'string' ? value : value.toString()}
      onChange={e => {
        e.stopPropagation();
        onChange(value);
      }}
      {...props}
    />
    <StyledLabel htmlFor={id}>{label}</StyledLabel>
  </RadioContainer>
);

export default RadioButton;
